module.exports = __webpack_public_path__ + "static/img/recruitmentSmallImg.8d94bfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/recruitmentSmallImg.png
// module id = SAiz
// module chunks = 1